/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleasetryagain2Inputs */

const en_pleasetryagain2 = /** @type {(inputs: Pleasetryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again.`)
};

const de_pleasetryagain2 = /** @type {(inputs: Pleasetryagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuch's nochmal.`)
};

/**
* | output |
* | --- |
* | "Please try again." |
*
* @param {Pleasetryagain2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleasetryagain2 = /** @type {((inputs?: Pleasetryagain2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleasetryagain2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleasetryagain2(inputs)
	return de_pleasetryagain2(inputs)
});
export { pleasetryagain2 as "pleaseTryAgain" }